import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import CategoryZone from './components/CategoryZone';
import MomentShowcase from './components/MomentShowcase';
import FeedsSection from './components/FeedsSection';
import BrandStrip from './components/BrandStrip';
import FaqSection from './components/FaqSection';
import SubscribeSection from './components/SubscribeSection';
import Footer from './components/Footer';

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
    </a>
  );
}

export default function Home() {
  return (
    <div className="bg-background-50">
      <Header />
      <main>
        <Hero />
        <HotRank />
        <CategoryZone />
        <MomentShowcase />
        <FeedsSection />
        <BrandStrip />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}